import { FC, useCallback, useEffect, useState } from "react"
import { format, parse } from "date-fns";
import HighCharts from "highcharts/highstock";
import HighchartsReact from 'highcharts-react-official'

import { LINE_CHART } from "src/constants/highCharts";
import { CaseVolumeProps } from "./types";
import { COLOR_LIST } from "src/constants/stats";
import CustomButtonRight from "../customButtonRight";



const CaseVolume: FC<CaseVolumeProps> = ({ statsData, isButtonPanelVisible }): JSX.Element => {
  const [lineChart, setLineChart] = useState(LINE_CHART);

  const isNotStatsPage = window.location.href.includes("statistics") ? false : true;


  const populateLineBase = () => {
    let allDates: any[] = [];
    statsData.case_volume.forEach((caseVolume: any) => {
      allDates = allDates.concat(Object.keys(caseVolume.data));
    });

    return Array.from(new Set(allDates)).map((item) => parse(item, "yyyy-MM-dd", new Date())).sort((a: Date, b: Date) => (a < b) ? -1 : 1);
  };

  // Populate line chart options with x-axis and series data
  const populateLineChart = useCallback(() => {
    const lineOptions = { ...lineChart };
    lineOptions.series = wrapperFunctionForLine();
    lineOptions.xAxis = {
      categories: populateLineBase().map((item) => format(item, "dd. MMM")),
    };
    setLineChart(lineOptions);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statsData.case_volume]);


  // Create a unified array of unique dates for the x-axis
  const wrapperFunctionForBaseAxis = () => {
    let allDates: any[] = [];

    statsData.case_volume.forEach((caseVolume) => {
      if (caseVolume.data)
        allDates = allDates.concat(Object.keys(caseVolume.data));
    });

    // const updatedDates = allDates.map((item) => format(item, "MM-dd-yyyy"));
    // return Array.from(new Set(updatedDates)).sort(); // Remove duplicates and sort the dates
    const updatedDates = allDates.map((item) => format(parse(item, "yyyy-MM-dd", new Date()), "MM-dd-yyyy"));
    return Array.from(new Set(updatedDates)).sort(); // Remove duplicates and sort the dates
  };



  // Map data to the line series, filling missing dates with null
  const wrapperFunctionForLine = () => {
    let lineSeriesArray: any = [];
    const xAxisDates = wrapperFunctionForBaseAxis(); // Get the unique x-axis dates

    statsData.case_volume.forEach((caseVolume,index) => {
      let seriesData: any = [];

      // Map over the xAxisDates, inserting data or null if missing
      xAxisDates.forEach((date) => {
        if (caseVolume.data) {
          // const formattedDate = format(parse(date, "MM-dd-yyyy", new Date()), "yyyy-MM-dd");
          // if (caseVolume.data[formattedDate] !== undefined) {
          //   seriesData.push(caseVolume.data[formattedDate]);
          // } else {
          //   seriesData.push(0); // Insert null for missing dates
          // }
          const formattedDate = format(parse(date, "MM-dd-yyyy", new Date()), "yyyy-MM-dd");
          seriesData.push(caseVolume.data[formattedDate] || 0);
        }
      });

      lineSeriesArray.push({
        type: "spline",
        name: 
          isNotStatsPage && 
            (caseVolume.name.toLowerCase().includes("received") || caseVolume.name.toLowerCase().includes("completed")) 
              ? (!caseVolume.name.toLowerCase().includes("total") ? `Total ${caseVolume.name}` : caseVolume.name) :
              caseVolume.name,
        data: seriesData,
        color: COLOR_LIST[index],
        boostThreshold: 0,
      });
    });

    return lineSeriesArray;
  };

  useEffect(() => {
    populateLineChart();
  }, [populateLineChart]);



  return (
    <div className="row gx-3 mt-3">
      <div
        className={isButtonPanelVisible ? "col-12 col-sm-12 col-md-9" : "col"}
        style={{ maxHeight: 550 }}
      >
        <div className="card">
          <div className="card-header">
            <h4 className="text-center m-0">Case Volume</h4>
          </div>
          <div className="card-body">
            <p className="text-center">Line convergence is positive, and higher numbers are better.</p>
            <div className="row">
              <HighchartsReact highcharts={HighCharts} options={lineChart} />
            </div>
          </div>
        </div>
      </div>

      {isButtonPanelVisible && (
        <div className="col-12 col-sm-12 col-md-3 mt-4 mt-sm-4 mt-md-0 d-flex flex-column" style={{ maxHeight: 550, alignItems: "stretch" }}>
          <CustomButtonRight statisticsObject={statsData} />
        </div>
      )}
    </div>
  )
}

export default CaseVolume;

